__turbopack_context__.v({
  "maxLines": "text-module__FnhqzG__maxLines",
  "raw": "text-module__FnhqzG__raw",
  "text": "text-module__FnhqzG__text",
});
